import { IMAGES } from "@/components/landing/images";

const CARDS = [
  { src: IMAGES.gallery1, alt: "Support worker helping a participant with cooking in a home kitchen", label: "In-Home & Daily Living" },
  { src: IMAGES.gallery2, alt: "Participant and companion enjoying coffee at a South Australian community park", label: "Community Outings" },
  { src: IMAGES.gallery3, alt: "Support coordinator reviewing NDIS plan documents with a family", label: "Support Coordination" },
  { src: IMAGES.gallery4, alt: "Respite worker doing a craft activity with a young adult at home", label: "Respite & Household Help" },
];

export default function Gallery() {
  return (
    <section className="py-16 px-5 sm:px-8 bg-[#FAF8F5]" data-testid="gallery-section">
      <div className="max-w-6xl mx-auto space-y-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <span className="text-xs uppercase tracking-widest text-[#786655] font-semibold">Our Daily Standard</span>
            <h2 className="text-2xl sm:text-3xl font-display font-medium text-[#1E282D]">Everyday moments, supported with care</h2>
          </div>
          <p className="text-sm text-[#5C6A71] max-w-md">Real in-home care, genuine community inclusion, and support coordination built around your goals.</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 pt-2">
          {CARDS.map((card, i) => (
            <div key={card.label} className="group relative aspect-[4/3] rounded-2xl overflow-hidden border border-[#E3D9CC] reveal" style={{ animationDelay: `${i * 0.08}s` }}>
              <img src={card.src} alt={card.alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1E282D]/40 via-transparent to-transparent" />
              <div className="absolute inset-x-0 bottom-0 flex items-end p-4">
                <span className="text-xs font-medium text-[#2E3B42] bg-[#FAF8F5]/85 backdrop-blur-sm px-2.5 py-1 rounded-md">{card.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
